<template>
  <section class="features-section">
    <v-container class="container-xxl" grid-list-xl py-0>
      <h2 class="g-title text-transform-none text-xs-center mb-3 mt-0">{{ $t('headers.the_benefits_of_being_a_giver_community_member')}}</h2>
      <p class="g-subtitle mb-5">{{ $t('we_believe')}}</p>
      <v-layout row wrap mt-4>
        <v-flex lg3 md3 sm6 xs12>
          <div class="feature-block _feature-block">
            <div class="text-center feature-blocks-item">
              <img src="../../assets/images/icons/box.svg" alt="">
              <h4>{{ $t('features.give_and_receive_value')}}</h4>
              <p class="text-for-3-lines">
                {{ $t('features.give_and_receive_value_text')}}
              </p>
            </div>
            <router-link to="/benefits" class="explore-btn">{{ $t('categories.more')}}</router-link>
          </div>
        </v-flex>
        <v-flex lg3 md3 sm6 xs12>
          <div class="feature-block _feature-block">
            <div class="text-center feature-blocks-item">
              <img src="../../assets/images/icons/handshake.svg" alt="">
              <h4>{{ $t('features.find_gift_recipient')}}</h4>
              <p class="text-for-3-lines">
                {{ $t('features.find_gift_recipient_text')}}
              </p>
            </div>
            <router-link to="/benefits" class="explore-btn">{{ $t('categories.more')}}</router-link>
          </div>
        </v-flex>
        <v-flex lg3 md3 sm6 xs12>
          <div class="feature-block _feature-block">
            <div class="text-center feature-blocks-item">
              <img src="../../assets/images/icons/donation.svg" alt="">
              <h4>
                {{ $t('features.no_exchange')}}
              </h4>
              <p class="text-for-3-lines">
                {{ $t('features.no_exchange_text')}}
              </p>
            </div>
            <router-link to="/benefits" class="explore-btn">{{ $t('categories.more')}}</router-link>
          </div>
        </v-flex>
        <v-flex lg3 md3 sm6 xs12>
          <div class="feature-block _feature-block">
            <div class="text-center feature-blocks-item">
              <img src="../../assets/images/icons/donate.svg" alt="">
              <h4>
                {{ $t('features.non_trade')}}
              </h4>
              <p class="text-for-3-lines">
                {{ $t('features.non_trade_text')}}
              </p>
            </div>
            <router-link to="/benefits" class="explore-btn">{{ $t('categories.more')}}</router-link>
          </div>
        </v-flex>
      </v-layout>
      <div class="text-xs-center mt-4" v-if="!loggedUser.id && showModalButtons">
        <v-btn class="g-btn-main g-middle-btn g-up-letter" @click="openRegModal">{{ $t('become_a_member')}}</v-btn>
      </div>
    </v-container>
  </section>
</template>

<script>
import mainMixins from '../../helpers/_mixins'
export default {
  mixins: [ mainMixins ],
  name: 'Features',
  props: ['loggedUser', 'showModalButtons'],
  methods: {
    openLogModal () {
      this.$emit('openLogModal')
    },
    openRegModal () {
      this.$emit('openRegModal')
    },
    elipsesLoad () {
      Array.from(document.querySelectorAll('.features-section .text-for-3-lines')).forEach(elem => {
        elem.style.maxHeight = '80px'
        setTimeout(() => {
          elem.style.opacity = '1'
        }, 10)
        this.textElipsise(elem)
      })
    }
  },
  mounted () {
    // for cutting very long texts
    setTimeout(() => {
      this.elipsesLoad()
    }, 0)
    window.addEventListener('DOMContentLoaded', () => {
      this.elipsesLoad()
    })
    window.addEventListener('resize', () => {
      this.elipsesLoad()
    })
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/desktop/mainPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/welcomePage/Features.vue